import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Container, Row, Col, Button } from 'react-bootstrap';
import RegBreadcrumb from '../components/RegBreadcrumb';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPrint } from "@fortawesome/free-solid-svg-icons";
import { TailSpin } from 'react-loader-spinner';
import { accountService } from '../functions/registerApi';
import { paymentService } from '../functions/PaymentDone';
import { authService } from '../functions/authenticate';


const PaymentDone = ({ itemList, marathonPrice, marathonLabel, userID, setUserID, setUserName, login, setLogin, authToken, setAuthToken  }) => {
    
    const navigate = useNavigate();
    const { paymentID } = useParams();
    const [status, setStatus] = useState(false);
    const [isGroup, setIsGroup] = useState(false);
    const [errDesc, setErrDesc] = useState('');
    const [contactName, setContactName] = useState('');
    const [hasConfirmation, setHasConfirmation] = useState(false);

    const handlePrint = (e) => {
        e.preventDefault();
        window.open(process.env.REACT_APP_PUBLIC_URL + `/payment/download_chit.php?paymentID=${paymentID}`);
    }

    const handleRedirect = (e) => {
        e.preventDefault();

        var device = localStorage.getItem('device');
        var userAgent = userAgent = navigator.userAgent;
        userAgent = userAgent.toLowerCase();
        var Android = userAgent.indexOf("android") > -1; 
        var iOS = userAgent.indexOf("ipad") > -1 || userAgent.indexOf("iphone") > -1 || userAgent.indexOf("ipod") > -1;

        // switch(device) {
        //     case 'android': 
        //         localStorage.removeItem('device');
        //         window.open(`https://www.marathonkuching.com/mobileApp`);
        //     case 'ios' :
        //         localStorage.removeItem('device');
        //         window.open(`kuchingMarathonApp://`);
        //     default : 
        //         window.open(process.env.REACT_APP_PUBLIC_URL + `/Register`);
        // }

        // alert(device);

        if(Android) {
            localStorage.removeItem('device');
            window.open(`https://www.marathonkuching.com/mobileApp`);
        } else if(iOS) {
            localStorage.removeItem('device');
            window.open(`kuchingMarathonApp://`);
        } else {
            navigate('/Register');
        }

    }

    const remakePayment = (e) => {
        localStorage.setItem('RemakePayment', 'true');
        localStorage.setItem('paymentID', paymentID);
        navigate('/Payment');
    }

    useEffect(() => {

        localStorage.removeItem('RemakePayment');

        paymentService.getPaymentGroup(paymentID)
            .then((response) => {
                // console.log(response);
                if(response.status)
                {
                    let payment = response.body.payment;
                    let user = response.body.user;
                    let groupCode = response.body.groupCode;
                    var isInvoicing = false;

                    if(payment.groupCode !== "" && payment.groupCode !== null) setIsGroup(true); 
                    if(groupCode && groupCode.payment_type === 'Invoicing') isInvoicing = true; 

                    setContactName(user.firstname + ' ' + user.lastname);
                    if(payment.status === '1' || isInvoicing)
                    {
                        setStatus(true);

                        // let listCount = localStorage.getItem('selectedList')===null ? [] : JSON.parse(localStorage.getItem('selectedList'));
                        // if(listCount.length <= 0) {
                            setHasConfirmation(true);
                        // }

                        localStorage.removeItem('runnerList');
                        localStorage.removeItem('selectedList');
                        localStorage.removeItem('promoCode');
                        localStorage.removeItem('paymentID');
                        localStorage.removeItem('refID');
                        localStorage.removeItem('RemakePayment');
                        localStorage.removeItem('runnerCount');
                    }
                    else
                    {
                        setErrDesc(payment.err_desc);
                    }
                }
                else
                {
                    console.error('Failed to fetch data');

                }
            })
            // .catch(err => {
            //     console.error(err.response);
            // });
    }, []);

    useEffect(() => {
        const token = localStorage.getItem('authToken');
        if(token==='' || token===null)
        {
            navigate('/Login');
        }
        else
        {
            // console.log(token);
            authService.validateAuthToken(token)
                .then((response) => {
                    // console.log(response);
                    if(!response.status)
                    {
                        navigate('/Login');
                    }
                    else if(!login)
                    {
                        let data = response.body.user;
                        setUserID(data.individualID);
                        localStorage.setItem('userID', data.individualID);
                        // console.log(localStorage.getItem('userID'));
                        setLogin(true);

                        setUserName(data.firstname + ' ' + data.lastname);
                        localStorage.setItem('userName', data.firstname + ' ' + data.lastname);
                        
                        setAuthToken(response.body.token);
                        localStorage.setItem('authToken', response.body.token);

                    }
                })
                .catch((error) => {
                    console.log(error);
                    // navigate('/Login');
                })
        }
    }, [authToken]);

    return (
        <Container fluid="lg" className='wrapper'>
            
            <h1 className="title">Registration Status</h1>
            <RegBreadcrumb page={4} />

            <Row className="payment-loading-box">

                <h5>Dear {contactName},</h5>

                {status ? (
                    <>

                        {isGroup ? (
                            <>
                                <h3 className='mt-2 text-success'>Registration went through successfully.</h3>

                                <Row>
                                    <Col md={12} sm={12} className="mt-3">
                                        <h4>Reference ID: <strong>{paymentID}</strong></h4>
                                    </Col>
                                    <Col md={12} sm={12} className="mt-2">

                                    <p className="text-danger">
                                        Note: Thank you for your registration.
                                        Please take note this is acknowledge that we have received your registration confirmation.
                                        However, this acknowledgement does not serve as a confirmation of your registration.
                                    </p>

                                    <p className="text-danger">
                                        We will promptly process and issue an invoice for you to proceed with payment.
                                        Upon receiving payment of the registration fee, we shall confirm your registration, and an email
                                        confirmation chit will be issued.
                                    </p>

                                    <p>
                                        <strong>
                                            Please check JUNK/SPAM FOLDER for Confirmation if cannot find in INBOX
                                        </strong>
                                    </p>

                                    <a className="btn btn-secondary" onClick={handleRedirect} >
                                        Back to Home
                                    </a>

                                    </Col>
                                </Row>

                            </>
                        ) : (
                            <>

                            <h3 className='mt-2'> Your payment went through successfully.</h3>

                            <p>Please keep the following Reference ID for your reference.</p>
    
                            <Row>
                                <Col md={12} sm={12} className="">
                                    <h4>Reference ID: <strong>{paymentID}</strong></h4>
                                </Col>
                                <Col md={12} sm={12} className="mt-4">
                                    {/* <h5>Confirmation Chit</h5> */}

                                    {hasConfirmation && (
                                        <Button className="btn btn-warning" onClick={handlePrint}>
                                            <FontAwesomeIcon icon={faPrint}/>
                                            &nbsp;
                                            Confirmation Chit
                                        </Button>   
                                    )}

                                    &nbsp;
                                    <a className="btn btn-secondary" onClick={handleRedirect} >
                                        Back to Home
                                    </a>
                                </Col>
                            </Row>

                            </>
                        )}

                    </>
                ) : (
                    <>
                        <h3 className='mt-2'>Sorry! Your payment did not go through.</h3>

                        <Row>
                            <Col md={12} sm={12} className="">
                                <h4>Error Description : <strong>{errDesc}</strong></h4>
                                <Col md={12} sm={12} className="mt-4">
                                    {/* <strong>NOT TO WORRY, SIMPLY</strong>
                                    &nbsp;
                                    <Button className="btn btn-warning" onClick={remakePayment}>
                                        Proceed With Payment
                                    </Button> */}
                                </Col>
                            </Col>
                        </Row>
                    </>
                )}

                <Row>
                    <p>
                        For more inquiries please do not hesitate to contact us at <a href="mailto: support@marathonkuching.com" >support@marathonkuching.com</a>
                        <br />
                        Thank you.
                    </p>
                </Row>

            </Row>

        </Container>

        
    );
}

export default PaymentDone;